/* ===== Hero Section Lifecycle ===== */
(function() {
  if (window.__skHomeHeroLifecycle) {
    window.__skHomeHeroLifecycle.init(document);
    return;
  }

  function findWithin(root, selector) {
    if (root.matches && root.matches(selector)) return root;
    return root.querySelector ? root.querySelector(selector) : null;
  }

  function initializedWithin(root, selector, cleanupProperty) {
    var elements = [];
    if (root.matches && root.matches(selector)) elements.push(root);
    if (root.querySelectorAll) {
      Array.prototype.push.apply(elements, root.querySelectorAll(selector));
    }
    elements.forEach(function(element) {
      if (typeof element[cleanupProperty] === 'function') element[cleanupProperty]();
    });
  }

  function addMediaListener(query, handler) {
    if (!query) return;
    if (query.addEventListener) query.addEventListener('change', handler);
    else if (query.addListener) query.addListener(handler);
  }

  function removeMediaListener(query, handler) {
    if (!query) return;
    if (query.removeEventListener) query.removeEventListener('change', handler);
    else if (query.removeListener) query.removeListener(handler);
  }

  function initSlider(root) {
    var slider = findWithin(root, '#heroSlider');
    if (!slider || slider.__skHomeHeroSliderCleanup) return;

    var slides = slider.querySelectorAll('.hero-v3-slide');
    var main = slider.closest('.hero-v3-main') || slider.parentNode;
    var thumbs = main.querySelectorAll('.hero-v3-thumb');
    var nextButton = slider.querySelector('.hero-v3-arrow--next');
    var prevButton = slider.querySelector('.hero-v3-arrow--prev');
    var total = slides.length;
    var current = 0;
    var interval = parseInt(slider.getAttribute('data-slide-interval') || '6', 10) * 1000;
    var deferMobileAutoplay = slider.getAttribute('data-mobile-autoplay-after-interaction') === 'true';
    var mobileQuery = window.matchMedia ? window.matchMedia('(max-width: 768px)') : null;
    var isMobile = mobileQuery ? mobileQuery.matches : false;
    var pauseOnHover = !isMobile;
    var motionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var reducedMotion = motionQuery ? motionQuery.matches : false;
    var mobileInteractionUnlocked = false;
    var autoplayStarted = !(deferMobileAutoplay && isMobile);
    var interactionEvents = ['pointerdown', 'touchstart', 'keydown'];
    var interactionListening = false;
    var isHovered = false;
    var isFocusWithin = false;
    var timer;
    var exitTimers = [];
    var thumbHandlers = [];
    var touchX = 0;
    var pendingNavigation = 0;

    if (!total) return;

    function hydrateSlide(index) {
      var slide = slides[index];
      if (!slide) return null;
      Array.prototype.forEach.call(slide.querySelectorAll('[data-sk-hero-srcset]'), function(media) {
        media.setAttribute('srcset', media.getAttribute('data-sk-hero-srcset'));
        media.removeAttribute('data-sk-hero-srcset');
      });
      Array.prototype.forEach.call(slide.querySelectorAll('[data-sk-hero-src]'), function(image) {
        image.setAttribute('src', image.getAttribute('data-sk-hero-src'));
        image.removeAttribute('data-sk-hero-src');
      });
      return slide.querySelector('.hero-v3-img');
    }

    Array.prototype.forEach.call(slides, function(slide, index) {
      if (slide.classList.contains('active')) current = index;
      if (!isMobile) hydrateSlide(index);
    });

    function syncThumbs(shouldScroll) {
      Array.prototype.forEach.call(thumbs, function(thumb, idx) {
        var isActive = idx === current;
        thumb.classList.toggle('active', isActive);
        thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
        if (isActive && shouldScroll && thumb.scrollIntoView) {
          thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
      });
    }

    function resetTimer() {
      clearTimeout(timer);
      if (!autoplayStarted || reducedMotion || document.hidden || isHovered || isFocusWithin) return;
      timer = setTimeout(next, interval);
    }

    function activateSlide(idx, shouldScrollThumb) {
      var previous = current;
      current = idx;
      slides[previous].classList.remove('active');
      slides[previous].classList.add('exit');
      slides[current].classList.add('active');
      var exitTimer = setTimeout(function() {
        slides[previous].classList.remove('exit');
        exitTimers.splice(exitTimers.indexOf(exitTimer), 1);
      }, 800);
      exitTimers.push(exitTimer);
      syncThumbs(shouldScrollThumb === true);
      resetTimer();
    }

    function goTo(idx, shouldScrollThumb) {
      var target = (idx + total) % total;
      if (target === current) return;
      var image = hydrateSlide(target);
      var navigation = ++pendingNavigation;
      var activateWhenCurrent = function() {
        if (navigation !== pendingNavigation) return;
        activateSlide(target, shouldScrollThumb);
      };

      if (!image || (image.complete && image.naturalWidth > 1)) {
        activateWhenCurrent();
      } else {
        var settled = false;
        var cleanupImageWait = function() {
          if (settled) return false;
          settled = true;
          image.removeEventListener('load', activateLoadedImage);
          image.removeEventListener('error', keepCurrentSlide);
          return true;
        };
        var activateLoadedImage = function() {
          if (!cleanupImageWait()) return;
          activateWhenCurrent();
        };
        var keepCurrentSlide = function() {
          if (!cleanupImageWait()) return;
          if (navigation === pendingNavigation) resetTimer();
        };
        image.addEventListener('load', activateLoadedImage, { once: true });
        image.addEventListener('error', keepCurrentSlide, { once: true });
        if (typeof image.decode === 'function') {
          image.decode().then(activateLoadedImage, function() {
            if (image.complete && image.naturalWidth > 1) activateLoadedImage();
            else if (image.complete && image.currentSrc) keepCurrentSlide();
          });
        } else if (image.complete && image.naturalWidth > 1) {
          activateLoadedImage();
        } else if (image.complete && image.currentSrc) {
          keepCurrentSlide();
        }
      }
    }

    function next() { goTo(current + 1, false); }
    function prev() { goTo(current - 1 + total, false); }

    function removeInteractionListeners() {
      if (!interactionListening) return;
      interactionEvents.forEach(function(eventName) {
        document.removeEventListener(eventName, startAfterInteraction);
      });
      interactionListening = false;
    }

    function addInteractionListeners() {
      if (interactionListening || autoplayStarted || reducedMotion) return;
      interactionEvents.forEach(function(eventName) {
        document.addEventListener(eventName, startAfterInteraction, { passive: true });
      });
      interactionListening = true;
    }

    function startAfterInteraction() {
      if (autoplayStarted || reducedMotion) return;
      mobileInteractionUnlocked = true;
      autoplayStarted = true;
      hydrateSlide((current + 1) % total);
      removeInteractionListeners();
      resetTimer();
    }

    function onMobileChange(event) {
      isMobile = event.matches;
      pauseOnHover = !isMobile;
      isHovered = false;

      if (!isMobile) {
        Array.prototype.forEach.call(slides, function(slide, index) {
          hydrateSlide(index);
        });
        autoplayStarted = true;
        removeInteractionListeners();
      } else if (deferMobileAutoplay && !mobileInteractionUnlocked) {
        autoplayStarted = false;
        clearTimeout(timer);
        addInteractionListeners();
      } else {
        autoplayStarted = true;
        removeInteractionListeners();
      }
      resetTimer();
    }

    function onMouseEnter() {
      if (!pauseOnHover) return;
      isHovered = true;
      clearTimeout(timer);
    }

    function onMouseLeave() {
      if (!pauseOnHover) return;
      isHovered = false;
      resetTimer();
    }

    function onFocusIn() {
      isFocusWithin = true;
      clearTimeout(timer);
    }

    function onFocusOut(event) {
      if (event.relatedTarget && main.contains(event.relatedTarget)) return;
      isFocusWithin = false;
      resetTimer();
    }

    function onVisibilityChange() {
      if (document.hidden) clearTimeout(timer);
      else resetTimer();
    }

    function onMotionChange(event) {
      reducedMotion = event.matches;
      if (reducedMotion) {
        clearTimeout(timer);
        removeInteractionListeners();
      } else {
        autoplayStarted = !isMobile || !deferMobileAutoplay || mobileInteractionUnlocked;
        if (autoplayStarted) {
          removeInteractionListeners();
          resetTimer();
        } else {
          addInteractionListeners();
        }
      }
    }

    function onTouchStart(event) {
      touchX = event.touches[0].clientX;
    }

    function onTouchEnd(event) {
      var diff = touchX - event.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) diff > 0 ? next() : prev();
    }

    if (total <= 1) {
      if (nextButton) nextButton.style.display = 'none';
      if (prevButton) prevButton.style.display = 'none';
      syncThumbs(false);
      slider.__skHomeHeroSliderCleanup = function() {
        slider.__skHomeHeroSliderCleanup = null;
      };
      return;
    }

    if (nextButton) nextButton.addEventListener('click', next);
    if (prevButton) prevButton.addEventListener('click', prev);
    Array.prototype.forEach.call(thumbs, function(thumb) {
      var handler = function() {
        var idx = parseInt(thumb.getAttribute('data-slide-index') || '', 10);
        if (!isNaN(idx)) goTo(idx, true);
      };
      thumbHandlers.push({ thumb: thumb, handler: handler });
      thumb.addEventListener('click', handler);
    });
    slider.addEventListener('mouseenter', onMouseEnter);
    slider.addEventListener('mouseleave', onMouseLeave);
    main.addEventListener('focusin', onFocusIn);
    main.addEventListener('focusout', onFocusOut);
    slider.addEventListener('touchstart', onTouchStart, { passive: true });
    slider.addEventListener('touchend', onTouchEnd, { passive: true });
    document.addEventListener('visibilitychange', onVisibilityChange);
    addMediaListener(motionQuery, onMotionChange);
    addMediaListener(mobileQuery, onMobileChange);
    addInteractionListeners();

    slider.__skHomeHeroSliderCleanup = function() {
      clearTimeout(timer);
      pendingNavigation += 1;
      exitTimers.forEach(clearTimeout);
      removeInteractionListeners();
      if (nextButton) nextButton.removeEventListener('click', next);
      if (prevButton) prevButton.removeEventListener('click', prev);
      thumbHandlers.forEach(function(entry) {
        entry.thumb.removeEventListener('click', entry.handler);
      });
      slider.removeEventListener('mouseenter', onMouseEnter);
      slider.removeEventListener('mouseleave', onMouseLeave);
      main.removeEventListener('focusin', onFocusIn);
      main.removeEventListener('focusout', onFocusOut);
      slider.removeEventListener('touchstart', onTouchStart);
      slider.removeEventListener('touchend', onTouchEnd);
      document.removeEventListener('visibilitychange', onVisibilityChange);
      removeMediaListener(motionQuery, onMotionChange);
      removeMediaListener(mobileQuery, onMobileChange);
      slider.__skHomeHeroSliderCleanup = null;
    };

    syncThumbs(false);
    resetTimer();
  }

  function initArticleTabs(root) {
    var articles = findWithin(root, '.hero-v3-articles');
    if (!articles || articles.__skHomeHeroTabsCleanup) return;
    var buttons = articles.querySelectorAll('.hero-v3-tab-btn');
    var panels = articles.querySelectorAll('.hero-v3-tab-panel');
    var handlers = [];

    function selectTab(button, moveFocus) {
      Array.prototype.forEach.call(buttons, function(item) {
        var isSelected = item === button;
        item.classList.toggle('active', isSelected);
        item.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        item.setAttribute('tabindex', isSelected ? '0' : '-1');
      });
      Array.prototype.forEach.call(panels, function(panel) {
        var isSelected = panel.id === button.getAttribute('data-tab');
        panel.classList.toggle('active', isSelected);
        panel.hidden = !isSelected;
      });
      if (moveFocus) button.focus();
    }

    var initialButton = articles.querySelector('.hero-v3-tab-btn.active') || buttons[0];
    if (initialButton) selectTab(initialButton, false);

    Array.prototype.forEach.call(buttons, function(button, index) {
      var handler = function() {
        selectTab(button, false);
      };
      var keyHandler = function(event) {
        var targetIndex = index;
        if (event.key === 'ArrowRight') targetIndex = (index + 1) % buttons.length;
        else if (event.key === 'ArrowLeft') targetIndex = (index - 1 + buttons.length) % buttons.length;
        else if (event.key === 'Home') targetIndex = 0;
        else if (event.key === 'End') targetIndex = buttons.length - 1;
        else return;
        event.preventDefault();
        selectTab(buttons[targetIndex], true);
      };
      handlers.push({ button: button, handler: handler, keyHandler: keyHandler });
      button.addEventListener('click', handler);
      button.addEventListener('keydown', keyHandler);
    });

    var blockSelectHandler = function(event) {
      if (!event.target || !articles.contains(event.target)) return;
      var panel = event.target.closest ? event.target.closest('.hero-v3-tab-panel') : null;
      if (!panel) return;
      var button = articles.querySelector('.hero-v3-tab-btn[data-tab="' + panel.id + '"]');
      if (button) selectTab(button, false);
    };
    document.addEventListener('shopify:block:select', blockSelectHandler);

    articles.__skHomeHeroTabsCleanup = function() {
      handlers.forEach(function(entry) {
        entry.button.removeEventListener('click', entry.handler);
        entry.button.removeEventListener('keydown', entry.keyHandler);
      });
      document.removeEventListener('shopify:block:select', blockSelectHandler);
      articles.__skHomeHeroTabsCleanup = null;
    };
  }

  function initPickup(root) {
    var wrap = findWithin(root, '#pickupRotator');
    if (!wrap || wrap.__skHomeHeroPickupCleanup) return;
    var cards = wrap.querySelectorAll('.hero-v3-pickup');
    if (cards.length <= 1) return;
    var nav = findWithin(root, '.hero-v3-pickup-nav');
    var navButtons = nav ? nav.querySelectorAll('.hero-v3-pickup-nav-btn') : [];
    var motionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var reducedMotion = motionQuery ? motionQuery.matches : false;
    var isHovered = false;
    var isFocusWithin = false;
    var current = 0;
    var timer;
    var navHandlers = [];

    Array.prototype.forEach.call(cards, function(card, index) {
      if (card.classList.contains('active')) current = index;
    });

    function syncNav() {
      Array.prototype.forEach.call(navButtons, function(button, index) {
        var isActive = index === current;
        button.classList.toggle('active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    function schedule() {
      clearTimeout(timer);
      if (reducedMotion || document.hidden || isHovered || isFocusWithin) return;
      timer = setTimeout(rotate, 5000);
    }

    function rotate() {
      if (reducedMotion || document.hidden || isHovered || isFocusWithin) {
        schedule();
        return;
      }
      cards[current].classList.remove('active');
      current = (current + 1) % cards.length;
      cards[current].classList.add('active');
      syncNav();
      schedule();
    }

    function goToCard(index) {
      if (index === current || !cards[index]) return;
      cards[current].classList.remove('active');
      current = index;
      cards[current].classList.add('active');
      syncNav();
      schedule();
    }

    function onMouseEnter() {
      isHovered = true;
      clearTimeout(timer);
    }

    function onMouseLeave() {
      isHovered = false;
      schedule();
    }

    function onFocusIn() {
      isFocusWithin = true;
      clearTimeout(timer);
    }

    function onFocusOut(event) {
      if (event.relatedTarget && wrap.contains(event.relatedTarget)) return;
      isFocusWithin = false;
      schedule();
    }

    function onVisibilityChange() {
      if (document.hidden) clearTimeout(timer);
      else schedule();
    }

    function onMotionChange(event) {
      reducedMotion = event.matches;
      if (reducedMotion) clearTimeout(timer);
      else schedule();
    }

    wrap.addEventListener('mouseenter', onMouseEnter);
    wrap.addEventListener('mouseleave', onMouseLeave);
    wrap.addEventListener('focusin', onFocusIn);
    wrap.addEventListener('focusout', onFocusOut);
    document.addEventListener('visibilitychange', onVisibilityChange);
    addMediaListener(motionQuery, onMotionChange);
    Array.prototype.forEach.call(navButtons, function(button) {
      var handler = function() {
        var idx = parseInt(button.getAttribute('data-pickup-index') || '', 10);
        if (!isNaN(idx)) goToCard(idx);
      };
      navHandlers.push({ button: button, handler: handler });
      button.addEventListener('click', handler);
    });
    wrap.__skHomeHeroPickupCleanup = function() {
      clearTimeout(timer);
      wrap.removeEventListener('mouseenter', onMouseEnter);
      wrap.removeEventListener('mouseleave', onMouseLeave);
      wrap.removeEventListener('focusin', onFocusIn);
      wrap.removeEventListener('focusout', onFocusOut);
      document.removeEventListener('visibilitychange', onVisibilityChange);
      removeMediaListener(motionQuery, onMotionChange);
      navHandlers.forEach(function(entry) {
        entry.button.removeEventListener('click', entry.handler);
      });
      wrap.__skHomeHeroPickupCleanup = null;
    };
    schedule();
  }

  function initTrustBar(root) {
    var track = findWithin(root, '#trustTrack');
    if (!track) return;
    track.querySelectorAll('[data-trust-clone="true"]').forEach(function(item) {
      item.remove();
    });
  }

  function init(root) {
    initSlider(root);
    initArticleTabs(root);
    initPickup(root);
    initTrustBar(root);
  }

  function cleanup(root) {
    initializedWithin(root, '#heroSlider', '__skHomeHeroSliderCleanup');
    initializedWithin(root, '.hero-v3-articles', '__skHomeHeroTabsCleanup');
    initializedWithin(root, '#pickupRotator', '__skHomeHeroPickupCleanup');
  }

  window.__skHomeHeroLifecycle = { init: init, cleanup: cleanup };
  document.addEventListener('shopify:section:load', function(event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function(event) { cleanup(event.target); });
  init(document);
})();

/* ===== Scroll Animations ===== */
document.addEventListener('DOMContentLoaded', function() {
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) { if (e.isIntersecting) e.target.classList.add('visible'); });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('.sk-home .fade-up').forEach(function(el) { obs.observe(el); });
});
